import { render, staticRenderFns } from "./NgMoney.vue?vue&type=template&id=57ceacda"
import script from "./NgMoney.vue?vue&type=script&lang=js"
export * from "./NgMoney.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports